module.exports = __webpack_public_path__ + "static/media/shawn.f6280f30.jpeg";